// extracted by mini-css-extract-plugin
export var animatedGraphicContainer = "styles-module--animatedGraphicContainer--32ab3";
export var container = "styles-module--container--f8c5b";
export var heading = "styles-module--heading--f7362";
export var headings = "styles-module--headings--27ada";
export var text = "styles-module--text--a8e01";